import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { CUSTOM_SVG_ICONS } from './custom-svg-icons';

export function registerCustomSvgIcons(matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer): void {
  CUSTOM_SVG_ICONS.forEach(({ name, url }) =>
    matIconRegistry.addSvgIcon(name, domSanitizer.bypassSecurityTrustResourceUrl(url)),
  );
}
